import { render, staticRenderFns } from "./FoldingShutterDescription.vue?vue&type=template&id=42c4e49b&scoped=true"
import script from "./FoldingShutterDescription.vue?vue&type=script&lang=ts"
export * from "./FoldingShutterDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4e49b",
  null
  
)

export default component.exports